<button
  class="callback__button-desktop"
  type="button"
  mat-stroked-button
  (click)="openDialog()"
>
  <mat-icon svgIcon="phone"></mat-icon>
  Zadzwońcie do mnie
</button>
<button
  class="callback__button-mobile"
  type="button"
  mat-stroked-button
  (click)="openDialog()"
>
  <mat-icon svgIcon="phone"></mat-icon>
</button>
